/*
    clone: the two object without functions
*/
export default function cloneObject(obj) {
  const clone = {};
  for (const i in obj) {
    if (typeof obj[i] === "object" && obj[i] != null) {
      clone[i] = cloneObject(obj[i]);
    } else if (typeof obj[i] !== "function") {
      clone[i] = obj[i];
    }
  }
  return clone;
}
